import { atom } from "recoil";
//댕냥룸 콘테스트 전역 state

// cdn주소
export const cdnUrlConfig = atom({
    key: "cdn_config",
    default: "",
});

// 서버 환경
export const serverMode = atom({
    key: "server_mode",
    default: "",
});

//멤버번호
export const memberState = atom({
    key: "member_se",
    default: 0,
});

//본인 업로드 여부
export const myPostState = atom({
    key: "isMyPostExist",
    default: false,
})

//최신순 / 좋아요순
export const petHomeEventOrderFilter = atom({
    key: "orderFilter",
    default: "LATEST",
})

//메인 스크롤값 저장
export const scrollMemory = atom({
    key: "savedScroll",
    default: 0,
})

//댕냥룸 구경하기(더보기 페이지) 스크롤값 저장
export const morePageScroll = atom({
    key: "morePageScroll",
    default: 0,
})

//보기 방식 - 피드, 그리드
export const viewWayState = atom({
    key: "viewWay",
    default: "",
})

//댕냥룸 더보기 데이터 저장
export const moreListState = atom({
    key: "moreList",
    default: [],
})

export const moreListPage = atom({
    key: "moreListPage",
    default: 1,
})